import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

// v1.40.0 Çek/Senet Teslim Tutanağı PDF'ini yeni sekmede aç
export const openHandover = async (id) => {
  const w = window.open("", "_blank");
  try {
    const r = await api.get(`/prim/payments/${id}/teslim-tutanagi.pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    if (w) w.location.href = url; else window.location.href = url;
  } catch (e) { w?.close(); toast.error(apiError(e)); }
};
